/**
 * The lifecycle state machines — game-neutral (no over/under vocabulary), so they
 * belong in the lifecycle half (the future `game-core`). Each machine is declared as
 * data (a state -> allowed-next-states table transcribed from the state tables in
 * docs/02-design/game-logic.md); the guard logic is shared by one small helper.
 *
 * This is structure only: the guards answer "is this transition legal", they do not
 * perform transitions or carry side effects. Terminal states map to an empty list.
 */
function defineStateMachine(transitions) {
    const states = Object.keys(transitions);
    return {
        states,
        allowedFrom: (state) => transitions[state],
        canTransition: (from, to) => transitions[from].includes(to),
        isTerminal: (state) => transitions[state].length === 0,
    };
}
export const contestStateMachine = defineStateMachine({
    Scheduled: ['Open', 'Canceled'],
    Open: ['Closed', 'Canceled'],
    Closed: ['Settled', 'Canceled'],
    Settled: [],
    Canceled: [],
});
export const entryStateMachine = defineStateMachine({
    Editable: ['Locked', 'Voided'],
    Locked: ['Settled', 'Voided'],
    Settled: [],
    Voided: [],
});
export const awardStateMachine = defineStateMachine({
    Pending: ['Processing', 'Canceled'],
    Processing: ['Delivered', 'Retryable', 'Failed'],
    Delivered: [],
    Retryable: ['Processing', 'Canceled'],
    Failed: ['Retryable', 'Canceled'],
    Canceled: [],
});
//# sourceMappingURL=state.js.map